import LinearProgress from '@mui/material/LinearProgress'
import { useTranslation } from 'react-i18next'

interface IProps {
  messageId?: string
  hasSubMessage?: boolean
}

const LoadingDialog = ({ messageId = 'loading', hasSubMessage = false }: IProps) => {
  const { t } = useTranslation()
  return (
    <div className="loading-progress" data-testid="loading-progress-bar">
      <div className="loading-progress__content">
        <h1>{t(messageId)}</h1>
        <LinearProgress color="primary" />
        {hasSubMessage ? <div className="curly-quotes">{t('under_loading_message')}</div> : null}
      </div>
    </div>
  )
}

export default LoadingDialog
